







































import { Vue, Component, Prop } from "vue-property-decorator";
import { LecturePage as ILecturePage } from "@/api/models/lecture-page";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
@Component
export default class lectureTextView extends Vue {
  @Prop() lecturePages?: Array<ILecturePage>;
  @Prop({ default: false }) isLecture?: boolean;
  currentLecturePage!: ILecturePage | undefined;
  activeLecturePage: number = 0;

  data() {
    return {
      currentLecturePage: undefined
    };
  }

  getCurrentLecturePage(index: number = 0) {
    this.currentLecturePage = undefined;
    if (this.lecturePages) {
      this.getMethodByProp(index)
        .then((res: { data: ILecturePage }) => {
          this.currentLecturePage = res.data;
          this.activeLecturePage = index;
          this.$emit("scrollToUp");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getMethodByProp(index: number) {
    let method: any;

    if (this.isLecture && this.lecturePages?.length)
      method = api.LecturePageApi.get(
        this.$route.params.id,
        this.lecturePages[index].id
      );

    if (!this.isLecture && this.lecturePages?.length)
      method = api.CourseLectureApi.getPage(
        this.$route.params.courseId,
        this.$route.params.courseLectureId,
        this.lecturePages[index].id
      );

    return method;
  }

  created() {
    this.getCurrentLecturePage();
  }

  beforeMount() {
    document.addEventListener("keyup", this.handleKeydown);
  }
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeydown);
  }

  handleKeydown(e: any) {
    if (e.code === "ArrowRight") {
      if (
        this.lecturePages &&
        this.activeLecturePage < this.lecturePages.length - 1
      ) {
        this.getCurrentLecturePage(this.activeLecturePage + 1);
      }
    }
    if (e.code === "ArrowLeft") {
      if (this.activeLecturePage !== 0) {
        this.getCurrentLecturePage(this.activeLecturePage - 1);
      }
    }
  }
}
